import { __assign } from "tslib";
import React from 'react';
import { WrapperItem } from '../components/wrapper-item';
import { SectionItemGridHorizontal } from './section-item-grid/section-item-grid-horizontal';
import { SectionItemGridVertical } from './section-item-grid/section-item-grid-vertical';
export function SectionItemGrid(props) {
    var section = props.section;
    var layout = section.layout || 'vertical';
    return (React.createElement(WrapperItem, null,
        layout === 'vertical' && React.createElement(SectionItemGridVertical, __assign({}, props)),
        layout === 'horizontal' && React.createElement(SectionItemGridHorizontal, __assign({}, props))));
}
//# sourceMappingURL=section-item-grid.js.map